import { SiteHeader } from './js/SiteHeader'
import { SearchBar } from './js/SearchBar'
import { LanguageSwitcher } from './js/LanguageSwitcher'
import { NewsletterSignup } from './js/NewsletterSignup'

customElements.define('site-header-v2', SiteHeader)
customElements.define('search-bar', SearchBar)
customElements.define('language-switcher', LanguageSwitcher)
customElements.define('newsletter-signup', NewsletterSignup)
